<button nz-button class="{{buttonClass}}" [nzLoading]="loading" (click)="handleClick()">{{label}}</button>
